import { createContext } from 'react'

/**
 * Lightweight context for readability mode state.
 *
 * Consumed by `useSizing` to bump sizing presets one level up when active.
 * Returns `false` when used outside a provider (e.g., in Settings).
 *
 * @since 1.0.0
 */
const ReadabilityContext = createContext<boolean>(false)

export const ReadabilityProvider = ReadabilityContext.Provider
